<template>

    <div class="library-filters" v-if="got_data" :class="{'select-box-open': active_filters.open !== null}">
        <label>Filter workouts:</label>
        <div class="select-header">
            <span class="filter-select"
                  :class="{active: active_filters.open === 'levels'}"
                  @click="openFilter('levels')"
            >
            <span v-text="doText('levels', 'level')"></span>
            </span>
            <span class="filter-select"
                  :class="{active: active_filters.open === 'cats'}"
                  @click="openFilter('cats')"
            >
            <span v-text="doText('cats', 'category')"></span>
            </span>
            <span class="filter-select"
                  :class="{active: active_filters.open === 'durations'}"
                  @click="openFilter('durations')"
            >
            <span v-text="doText('durations', 'duration')"></span>
            </span>
        </div>
        <div class="select-body" v-if="active_filters.open">
            <span class="tail">
                <span :class="{active: active_filters.open === 'levels'}"></span>
                <span :class="{active: active_filters.open === 'cats'}"></span>
                <span :class="{active: active_filters.open === 'durations'}"></span>
            </span>
            <ul>
                <li
                    v-for="(item, index) in active_filters[active_filters.open]"
                    @click="selectFilter(item.key)"
                    :class="{active: active_filters[active_filters.open][index].active}"
                >{{ item.title }}</li>
            </ul>
        </div>
        <div class="filter-reset-btn" v-if="active_tags.length > 0" @click="resetAllFilters()"></div>
        <div class="filter-favorites-btn" v-if="context === 'all'" :class="'starred_'+starred" @click="toggleStarred"></div>
    </div>

</template>

<script>

export default {
	props: [
        'filters',
        'context'
    ],
	data(){
		return {
			got_data: false,
		    active_filters: {
                open: null,
                cats: [],
                levels: [],
                durations: []
            },
            starred: 'none',
            active_tags: []
        }
    },
    mounted(){

    },
    methods: {
		toggleStarred()
        {
            let new_val = null;
            switch(this.starred)
            {
              case 'none':
                new_val = 'yellow';
                break;
              case 'yellow':
                new_val = 'green';
                break;
              case 'green':
                new_val = 'none';
                break;
              default:
                new_val = 'none';
            }

            this.starred = new_val;
            this.$emit('toggleStarred', new_val);
        },
		resetAllFilters(){
            for(const key in this.filters){
                if(this.filters.hasOwnProperty(key)){
                    for(let i=0; i<this.active_filters[key].length; i++){
                        this.active_filters[key][i].active = false;
                    }
                }
            }
            this.active_tags = [];
            this.active_filters.open = null;
            this.$emit('filterSelected', this.active_tags);
        },
		selectFilter(tag_key){
			let array = this.active_filters[this.active_filters.open];

			let multi_select = false;
			switch(this.active_filters.open){
				case 'levels':
                case 'durations':
                	multi_select = false;

                	break;
				case 'cats':
					multi_select = true;
					break;
			}

            for(let i=0; i<array.length; i++){
	            if(!multi_select && array[i].key !== tag_key){
		            array[i].active = false;
                    for(let j=0; j<this.active_tags.length; j++){
                        if(this.active_tags[j] === array[i].key){
                            this.active_tags.splice(j,1);
                        }
                    }
	            }
	            if(array[i].key === tag_key){
                    if(!array[i].active){
                    	array[i].active = true;
                    	this.active_tags.push(tag_key);
                    }else {
                    	array[i].active = false;
                    	for(let j=0; j<this.active_tags.length; j++){
                    	    if(this.active_tags[j] === tag_key){
                    	    	this.active_tags.splice(j,1);
                            }
                    	}
                    }
                }
            }
            if(!multi_select){
                // this.active_filters.open = null;
            }
            this.$emit('filterSelected', this.active_tags);
            this.$forceUpdate();
        },
		doText(key_name, singular_name){
			const array = this.active_filters[key_name];
			let active_count = 0;
			let active_title;
			for(let i=0; i<array.length; i++){
			    if(array[i].active){
			    	active_title = array[i].title;
			    	active_count++;
                }
			}
			if(!active_count){
				return singular_name;
			}else if(active_count === 1){
				return singular_name + ': ' + active_title;
			}else{
				return singular_name + ': ' + active_count + ' selected';
            }
        },
		initializeFilters()
        {
            for(const key in this.filters){
                if(this.filters.hasOwnProperty(key)){

                    // this.$set(this.active_filters, key, this.filters[key]);

                    this.active_filters[key] = this.filters[key];

                    this.active_filters.open = null;

                    for(let i=0; i<this.filters.length; i++){
                        // this.$set(this.active_filters[key], i, this.filters[key][i]);
                        this.active_filters[key][i] = this.filters[key][i];
                        this.active_filters[key][i].active = false;
                    }
                }
            }
        },
        openFilter(filter_name)
        {
			this.active_filters.open = filter_name === this.active_filters.open ? null : filter_name;
        }
    },
    watch: {
        filters()
        {
        	if(this.got_data) return;
        	this.got_data = true;
        	this.initializeFilters();
        }
    }
}

</script>
